import { useMutation } from '@apollo/client';
import { addBehavioralAudienceInsightMutation } from 'api/mutations/customInsight';
import {
  BehavioralSettings,
  BehavioralInsightPresentationMode,
  EventTypes,
} from 'modules/domains/segmentation';

type AddCustomInsightResponse = {
  addBehavioralAudienceInsight: { success: boolean };
};

type AddCustomInsightRequest = BehavioralSettings;

export const useAddCustomBehavioralInsight = () => {
  const [addBehavioralAudienceInsight, { data, loading, called, error }] = useMutation<
    AddCustomInsightResponse,
    AddCustomInsightRequest
  >(addBehavioralAudienceInsightMutation);

  const addCustomBehavioralInsight = (
    eventName: string,
    presentationMode: BehavioralInsightPresentationMode,
    dataType: EventTypes,
  ) => {
    addBehavioralAudienceInsight({ variables: { eventName, presentationMode, dataType } });
  };

  return {
    addCustomBehavioralInsight,
    data: data ?? null,
    isLoading: loading,
    isCalled: called,
    isSuccess: !loading && !!data?.addBehavioralAudienceInsight.success,
    isError: !loading && (!data?.addBehavioralAudienceInsight.success || !!error),
  };
};
